import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { images } from "@/mocks/site";

export default function Hero() {
  return (
    <section className="relative flex min-h-screen items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={images.heroWide}
          alt="Cinematic kitchen scene from the world of Chef Eddie G"
          title="The World of Chef Eddie G"
          className="h-full w-full object-cover object-center animate-kenburns"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/85" />
      <div className="absolute inset-0 bg-foreground-950/15" />

      <div className="relative z-10 w-full px-5 md:px-10 lg:px-16 text-center">
        <Reveal>
          <p className="eyebrow text-primary-300">
            Chef · Storyteller · Traveler · Connector
          </p>
        </Reveal>

        <h1 className="mx-auto mt-6 max-w-5xl font-heading leading-[0.96] text-background-50">
          <Reveal delay={100}>
            <span className="block text-4xl tracking-[0.02em] sm:text-6xl md:text-7xl lg:text-8xl">
              THE WORLD
            </span>
          </Reveal>
          <Reveal delay={220}>
            <span className="my-2 block font-heading text-2xl italic text-primary-400 sm:text-3xl md:text-4xl">
              of
            </span>
          </Reveal>
          <Reveal delay={320}>
            <span className="block text-4xl tracking-[0.02em] sm:text-6xl md:text-7xl lg:text-8xl">
              CHEF EDDIE G
            </span>
          </Reveal>
        </h1>

        <Reveal delay={460}>
          <p className="mx-auto mt-8 max-w-xl font-heading text-lg italic text-background-50/80 md:text-2xl">
            Food. People. Places. Stories.
          </p>
        </Reveal>

        <Reveal delay={580}>
          <div className="mt-11 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <a href="#worlds" className="btn-primary">
              Enter the Journey
              <i className="ri-arrow-down-line text-base" />
            </a>
            <Link
              to="/bring-eddie"
              className="btn-ghost text-background-50/85 hover:bg-background-50 hover:text-foreground-950"
            >
              Work with Eddie
            </Link>
          </div>
        </Reveal>
      </div>

      <div className="absolute bottom-8 left-1/2 z-10 -translate-x-1/2">
        <div className="flex flex-col items-center gap-3">
          <span className="font-label text-[10px] uppercase tracking-label text-background-50/50">
            Scroll
          </span>
          <span className="block h-12 w-px bg-gradient-to-b from-primary-500 to-transparent animate-slowPan" />
        </div>
      </div>
    </section>
  );
}